import {Address} from "../../../data/models/address.model";

export class PaymentTransactionModel {
  amount: string;
  billingPlanId: string;
  invoiceText: string;
  transactionId: string;
  provider: PaymentProvider;
  status: string;
  subscriptionId: string;
  redirectUrl: string;
  wssId: string;
  orderObject: any;
  clientAddress: Address;
  authorizationId?: string
}

export enum PaymentProvider {
  BUCKAROO = "BUCKAROO",
  PAYPAL = "PAYPAL",
}
